import { platformSettingDefinitionSchema, } from './platform-setting-definition.contract.js';
export function definePlatformSetting(input) {
    const definition = Object.freeze(platformSettingDefinitionSchema.parse(input.definition));
    input.valueSchema.parse(definition.codedFallback);
    const migrations = [...(input.migrations ?? [])].sort((first, second) => first.fromVersion - second.fromVersion);
    const seenFromVersions = new Set();
    for (const migration of migrations) {
        if (!Number.isInteger(migration.fromVersion) ||
            !Number.isInteger(migration.toVersion) ||
            migration.fromVersion < 1 ||
            migration.toVersion !== migration.fromVersion + 1 ||
            migration.toVersion > definition.schemaVersion ||
            seenFromVersions.has(migration.fromVersion)) {
            throw new Error(`Invalid setting migration for ${definition.key}.`);
        }
        seenFromVersions.add(migration.fromVersion);
    }
    for (let version = 1; version < definition.schemaVersion; version += 1) {
        if (!seenFromVersions.has(version)) {
            throw new Error(`Missing setting migration for ${definition.key} from schema version ${version}.`);
        }
    }
    return Object.freeze({
        definition,
        valueSchema: input.valueSchema,
        migrations: Object.freeze(migrations),
    });
}
//# sourceMappingURL=platform-setting-registration.contract.js.map